import styled from "styled-components";

export const TerminateContractContainer = styled.div`
  background: ${({theme}) => theme.white};
  border: 1px solid ${({theme}) => theme.grayDivider};
  border-radius: 8px;
  padding: 32px 0 32px 0;

  h1 {
    padding: 0 32px 0 32px;
    font-size: 19px;
    font-weight: 700;
    line-height: 23px;
    letter-spacing: 0.4px;
    text-align: left;
    color: ${({theme}) => theme.black}
  }

  h3 {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.3px;
    color: ${({theme}) => theme.gray};
    margin-bottom: 32px;
  }

  section {
    padding: 32px;
    border-bottom: 1px solid ${({theme}) => theme.grayDivider};
  }

  .terminate-contract {
    padding: 32px 32px 0 0;
    width: 100%;
    display: flex;
    justify-content: end;
  }

  .detailed_reason {
    background: ${({theme}) => theme.grayLightest};
    border-radius: 8px;
    padding: 22px 16px;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.1px;
    color: ${({theme}) => theme.black}
  }

  .download-layoff-report {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${({theme}) => theme.accent};
    svg{
      margin-right: 10px;
    }

    :hover {
      cursor: pointer;
      text-decoration: underline;
    }

  }
`;
